export const ADMIN_SESSION_KEY = "iscan.platformAdminSession";
export const ADMIN_IMPERSONATION_KEY = "iscan.adminImpersonation";

export type AdminImpersonationSession = {
  targetUser: { id: string; email?: string; name?: string };
  businesses: { id: string; name: string; role: string }[];
  mode: "read_only";
  startedAt: string;
};

export function getAdminSessionToken() {
  return sessionStorage.getItem(ADMIN_SESSION_KEY) || "";
}

export function getAdminImpersonation(): AdminImpersonationSession | null {
  const raw = sessionStorage.getItem(ADMIN_IMPERSONATION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as AdminImpersonationSession;
    if (!parsed?.targetUser?.id || !Array.isArray(parsed.businesses)) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setAdminImpersonation(session: AdminImpersonationSession) {
  sessionStorage.setItem(ADMIN_IMPERSONATION_KEY, JSON.stringify(session));
}

export function clearAdminImpersonation() {
  sessionStorage.removeItem(ADMIN_IMPERSONATION_KEY);
}

export function adminImpersonationHeaders() {
  const impersonation = getAdminImpersonation();
  const adminSession = getAdminSessionToken();
  return impersonation && adminSession
    ? {
        "X-Admin-Session": adminSession,
        "X-Admin-Impersonate-User": impersonation.targetUser.id,
      }
    : {};
}
